import api from './client';

export const supplierManagementApi = {
  getSupplierAuthList: (keyword, isActive) => {
    const params = new URLSearchParams();
    if (keyword) params.append('keyword', keyword);
    if (isActive !== undefined && isActive !== null) params.append('is_active', isActive);
    return api.get(`/api/supplier-management/list?${params.toString()}`);
  },
  
  createSupplierAuth: (supplierCode, password) => {
    return api.post('/api/supplier-management/create', {
      supplier_code: supplierCode,
      password: password || null,
    });
  },
  
  updatePassword: (supplierCode, mode, newPassword) => {
    return api.put(`/api/supplier-management/${supplierCode}/password`, {
      mode,
      new_password: newPassword || null,
    });
  },
  
  updateStatus: (supplierCode, isActive) => {
    return api.put(`/api/supplier-management/${supplierCode}/status`, {
      is_active: isActive,
    });
  },
};
